import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import LateDeliveriesGrid from '../../../features/distributor/late-deliveries-grid/components/LateDeliveriesGrid';

export default function LateDeliveriesPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Late Deliveries')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<LateDeliveriesGrid />
			</div>
		</React.Fragment>
	)
} 
